<template>
  <el-dialog
    width="400px"
    :title="$t('selectPage.select_warehouse')"
    :visible="true"
    :before-close="handleClose"
    :close-on-click-modal="false"
    append-to-body
  >
    <el-form>
      <el-form-item label="">
        <el-cascader
            style="width: 100%"
          class="warehouse-code"
          v-model="loginForm.warehouseCode"
          @focus="getWarehouseList"
          @change="warehouseListChanged"
          :placeholder="$t('selectPage.select_placeholder')"
          :options="options_warehouseCode"
          :props="{ multiple: true }"
          collapse-tags
          clearable
        ></el-cascader>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{$t('selectPage.btn_cancel')}}</el-button>
      <el-button
          type="primary"
          @click="handleJump"
          :loading="loading"
          :disabled="disabled"
      >{{$t('selectPage.btn_enter_owms')}}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { cutWarehouseCode, getNewLoginWarehouseList } from "@/api/loginOWMS";
import { switchLogin } from "@/api/userCenterManage";
import { getCookie } from "../../utils/cookie";

export default {
  name: "selectWareHouse",
  props: ["selectedMenu"],
  data() {
    return {
      prevWarehouseCode: [],
      options_warehouseCode: [],
      loading: false,
      loadingWarehouse: false,
      loginForm: {
        warehouseCode: [],
      },
    };
  },
  computed: {
    disabled() {
      return !this.loginForm.warehouseCode.map((item) => item[1]).join(",")
        .length;
    },
  },
  mounted() {
    this.getWarehouseList();
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleConfirm() {
      this.$emit("close");
    },

    async handleJump() {
      try {
        this.loading = true;
        const owmsToken = window.sessionStorage.getItem("OWMS_OWMS_TOKEN");
        const selectedWarehouse = this.loginForm.warehouseCode
          .map((item) => item[1])
          .join(",");
        const res = await cutWarehouseCode(owmsToken, {
          warehouseCode: selectedWarehouse,
        });
        const time = res.data;
        let data = JSON.parse(window.sessionStorage.getItem("OWMS_DATA"));
        data.warehouseCode = selectedWarehouse;
        const language = getCookie('language') || 'zh'
        try {
          await switchLogin({ systemId: this.selectedMenu.id, token: data.token, userId: data.rmsUserId })
        } catch (error) { }
        const url = `${this.selectedMenu.savePath}#/?withToken=true&time=${time}&data=${JSON.stringify(data)}&isFromWIMS=true&language=${language}`;
        window.location.replace(url)
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.$message.error("请确保权限并重新登录");
      }
    },
    warehouseListChanged(val) {
      if (this.prevWarehouseCode.length !== 0) {
        const onlyKey = this.prevWarehouseCode[0][0];
        const keys = [...new Set(val.map((item) => item[0]))];
        if (keys.length > 1) {
          this.loginForm.warehouseCode = this.loginForm.warehouseCode.filter(
            (item) => item[0] !== onlyKey
          );
        }
      }
      this.prevWarehouseCode = this.loginForm.warehouseCode || [];
    },
    async getWarehouseList() {
      this.loadingWarehouse = true;
      const options_warehouseCode = [];
      let res = await getNewLoginWarehouseList({
        userName: getCookie("userName"),
      });
      if (res.code !== "200") {
        this.$message.error("Error");
        return;
      }
      const data = res.data;

      // 处理登录仓库选择
      let options = {};
      data.forEach((item) => {
        if (!options[item.groupName]) {
          options[item.groupName] = [];
        }
        options[item.groupName].push({
          value: item.warehouseCode,
          label: item.warehouseCode,
        });
      });

      for (const optionsKey in options) {
        options_warehouseCode.push({
          value: optionsKey,
          label: optionsKey,
          children: options[optionsKey],
        });
      }
      this.options_warehouseCode = options_warehouseCode;
      this.loadingWarehouse = false;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-dialog__header {
    border-bottom: 1px solid rgb(231,231,231);
    padding: 15px 24px;
    >.el-dialog__title{
      font-weight: 600;
      font-size: 16px;
    }
  }
  .el-dialog__body{
    padding: 16px 24px;
  }
  .el-dialog__footer{
    border-top: 1px solid rgb(231,231,231);
    padding: 12px 24px;
    .el-button{
      font-size: 13px;
      padding: 8px 20px;
    }
  }
  .el-form--label-top{
    .el-form-item__label {
      color: #000000;
      padding: 4px 0;
      line-height: 14px;
      font-size: 12px;
      width: max-content;
    }
  }
}
.dialog-footer{
  text-align: right;
}
</style>
